__turbopack_context__.v({
  "blogGrid": "TravelInsights-module__zDfojW__blogGrid",
  "blogGridWrapper": "TravelInsights-module__zDfojW__blogGridWrapper",
  "blogSearchIcon": "TravelInsights-module__zDfojW__blogSearchIcon",
  "blogSearchInput": "TravelInsights-module__zDfojW__blogSearchInput",
  "blogSearchSubmit": "TravelInsights-module__zDfojW__blogSearchSubmit",
  "blogSearchWrapper": "TravelInsights-module__zDfojW__blogSearchWrapper",
  "categoryHeader": "TravelInsights-module__zDfojW__categoryHeader",
  "categoryHeaderContainer": "TravelInsights-module__zDfojW__categoryHeaderContainer",
  "categorySectionGroup": "TravelInsights-module__zDfojW__categorySectionGroup",
  "categorySectionTitle": "TravelInsights-module__zDfojW__categorySectionTitle",
  "categorySectionsWrapper": "TravelInsights-module__zDfojW__categorySectionsWrapper",
  "categoryTabActive": "TravelInsights-module__zDfojW__categoryTabActive",
  "categoryTabBtn": "TravelInsights-module__zDfojW__categoryTabBtn",
  "categoryTabsContainer": "TravelInsights-module__zDfojW__categoryTabsContainer",
  "loadMoreBtn": "TravelInsights-module__zDfojW__loadMoreBtn",
  "loadMoreWrap": "TravelInsights-module__zDfojW__loadMoreWrap",
  "loadingGif": "TravelInsights-module__zDfojW__loadingGif",
  "loadingWrap": "TravelInsights-module__zDfojW__loadingWrap",
  "loadingWrapBottom": "TravelInsights-module__zDfojW__loadingWrapBottom",
  "mobileScrollGrid": "TravelInsights-module__zDfojW__mobileScrollGrid",
  "travelInsightAlignLeft": "TravelInsights-module__zDfojW__travelInsightAlignLeft",
  "travelInsightArrowBtn": "TravelInsights-module__zDfojW__travelInsightArrowBtn",
  "travelInsightBody": "TravelInsights-module__zDfojW__travelInsightBody",
  "travelInsightCard": "TravelInsights-module__zDfojW__travelInsightCard",
  "travelInsightCardDescription": "TravelInsights-module__zDfojW__travelInsightCardDescription",
  "travelInsightCardImage": "TravelInsights-module__zDfojW__travelInsightCardImage",
  "travelInsightCardTitle": "TravelInsights-module__zDfojW__travelInsightCardTitle",
  "travelInsightCategoryIcon": "TravelInsights-module__zDfojW__travelInsightCategoryIcon",
  "travelInsightCategoryTag": "TravelInsights-module__zDfojW__travelInsightCategoryTag",
  "travelInsightDateBadge": "TravelInsights-module__zDfojW__travelInsightDateBadge",
  "travelInsightFooter": "TravelInsights-module__zDfojW__travelInsightFooter",
  "travelInsightHeader": "TravelInsights-module__zDfojW__travelInsightHeader",
  "travelInsightHeadingBlock": "TravelInsights-module__zDfojW__travelInsightHeadingBlock",
  "travelInsightImageLink": "TravelInsights-module__zDfojW__travelInsightImageLink",
  "travelInsightImageWrap": "TravelInsights-module__zDfojW__travelInsightImageWrap",
  "travelInsightMetaLeft": "TravelInsights-module__zDfojW__travelInsightMetaLeft",
  "travelInsightSection": "TravelInsights-module__zDfojW__travelInsightSection",
  "travelInsightShareBtn": "TravelInsights-module__zDfojW__travelInsightShareBtn",
  "travelInsightSlickSlide": "TravelInsights-module__zDfojW__travelInsightSlickSlide",
  "travelInsightSlickWrap": "TravelInsights-module__zDfojW__travelInsightSlickWrap",
  "travelInsightSliderMobile": "TravelInsights-module__zDfojW__travelInsightSliderMobile",
  "travelInsightTitleLink": "TravelInsights-module__zDfojW__travelInsightTitleLink",
  "travelInsightViews": "TravelInsights-module__zDfojW__travelInsightViews",
});
